export const sliderGalleryV0 = {
  elements: Array.from(
    document.querySelectorAll(".slider-gallery-v0 .swiper-container")
  ),
  details: (el) => ({
    // Optional parameters
    cssMode: true,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    // speed: 800,
    speed: 1500,
    effect: 'fade',
    threshold: 10,
    centeredSlides: false,
    // longSwipesRatio: 2,
    resistance: false, 
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
    },
    // fadeEffect: { crossFade: true },

    // Disable preloading of all images
    // preloadImages: false,
    // Enable lazy loading
    lazy: false,

    // If we need pagination
    pagination: {
      el: el.querySelector(".swiper-pagination"),
    },
    // Navigation arrows
    navigation: {
      nextEl: el.closest(".slider-gallery").querySelector(".swiper-button-next"),
      prevEl:el.closest(".slider-gallery").querySelector(".swiper-button-prev"),
    },
    breakpoints: {
      1023: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
  }),
};
